import { api, unwrap } from './client';

export function getSettings() {
  return unwrap(api.get('/api/settings'));
}

export function updateReservationFee(feePerPerson) {
  return unwrap(api.put('/api/settings/reservation-fee', { feePerPerson }));
}

export function getPilgrimageSchedule() {
  return unwrap(api.get('/api/settings/pilgrimage'));
}

export function savePilgrimageSchedule(payload) {
  return unwrap(api.put('/api/settings/pilgrimage', payload));
}
